import { render } from "./Assessment.vue?vue&type=template&id=7ffb23de&scoped=true&ts=true&lang=pug"
import script from "./Assessment.vue?vue&type=script&lang=ts"
export * from "./Assessment.vue?vue&type=script&lang=ts"

import "./Assessment.vue?vue&type=style&index=0&id=7ffb23de&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ffb23de"]])

export default __exports__